<!--suppress UnnecessaryLabelJS -->
<template>
	<v-data-table
		:headers="headers"
		:items="types"
		:loading="loading"
		class="elevation-1"
		:mobile-breakpoint="NaN"
	>
		<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
		<template #item="{item}">
			<type-row  :key="item.id" @edit="onEdit"   :type="item"/>
		</template>
	</v-data-table>
</template>

<script>
	import TypeRow from "src/view/types/TypeRow";
	import {types} from "src/store/modules/Type.module";
	import FilterAble from "src/mixins/FilterAble";

	export default {
		name: "types-table",
		props: [],
		components: {
			TypeRow
		},
		mixins: [new FilterAble(types)],
		data() {
			return {loading: false,
				headers: [
					{text: "name", value: "name"},
					{text: "מתאים לשאלות פתוחות", value: "open_question"},
					{text: "מתאים לשאלות סגורות", value: "close_question"},
					{text: "מתאים לשאלות כן ולא", value: "yes_no_question"},
					{text: "שם קובץ", value: "json_path"},

				],
				search: null,
				showDialog: false};
		},
		computed: {
			types() {
				return this.$store.state.TypeModule.types;
			}
		},
		methods: {
			onEdit(Type) {
				this.$emit("edit", Type);
			}
		}
	};
</script>

<style>

</style>
